<template>
	<div class="passWord">
		<span>请输入密码</span>
		<el-input v-model="password" placeholder="请输入密码" show-password autoComplete="new-password" @keyup.enter.native="submit"></el-input>
	</div>
</template>

<script>
import { Encrypt } from '@/utils/crypto';
import { mapGetters } from "vuex";

export default {
	props: {
		params: Object,
	},
	data() {
		return {
			password: "",
		};
	},
	computed: {
		...mapGetters(["userInfo"])
	},
	methods: {
		getCode() {
			return {
				type: "password",
				code: Encrypt(this.password)
			};
		},
		overTime() {
			this.$emit("overTime");
		},
		submit() {
			this.$emit("submit");
		}
	},
};
</script>

<style lang="scss" scoped>
.passWord {
	font-size: 14px;
	display: grid;
	grid-template-columns: 100px 200px 20px;
	grid-row-gap: 20px;
	grid-column-gap: 20px;
	align-items: center;
}
</style>